export default __webpack_public_path__ + "static/media/carousel20.bdc2130d.jpg";